/**
 * The warm-up rule (1.I-2 deliverable 27), pure: a press with the primary button over a mention
 * chip (`editor.mention.chip`), anywhere in the page, starts the pane chunk's import, so a click
 * that opens a peek finds the module loaded or on its way. Any other button, or a press anywhere
 * else, warms nothing. `OpenModes` attaches the listener only while `shell` is on.
 */

export const MENTION_CHIP = '[data-testid="editor.mention.chip"]';

/** What the rule reads of a `pointerdown`. */
export interface WarmEvent {
  readonly button: number;
  readonly target: EventTarget | null;
}

interface Closest {
  closest(selector: string): unknown;
}

const canClosest = (target: unknown): target is Closest =>
  typeof target === 'object' &&
  target !== null &&
  typeof (target as { closest?: unknown }).closest === 'function';

/** True for a primary-button press on a mention chip or inside one. */
export function shouldWarm(event: WarmEvent): boolean {
  if (event.button !== 0) return false;
  const target = event.target;
  return canClosest(target) && target.closest(MENTION_CHIP) !== null;
}
